// Import only the Bootstrap JavaScript components we actually use
import Collapse from "bootstrap/js/dist/collapse"
import Offcanvas from "bootstrap/js/dist/offcanvas"
import Tooltip from "bootstrap/js/dist/tooltip"

import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import sticky navigation handler
import "./sticky-nav.js"

// Import dropdown hover handler
import "./dropdown-hover.js"

// Import offcanvas menu handler
import "./offcanvas-menu.js"

// Import tooltip initialization handler
import "./tooltip-init.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Export form submit protection for use in page scripts
export { protectFormSubmission } from "./form-submit-protection.js"
